import React from "react";
import { Paper, Typography, Box } from "@mui/material";

const MaintenanceBanner = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '6px',
        width: "70%",
        color: "white",
        padding: "2rem",
        opacity: 0.9,
		background: "none",
		margin: '1px',
		boxShadow: "0px 2px 1px -1px rgba(255, 255, 255, 1),0px 1px 1px 0px rgba(255, 255, 255, 1),0px 1px 3px 0px rgba(255, 255, 255, 1)"
      }}
    >

      <Box component="ul" sx={{ paddingLeft: 2, margin: 0 }}>
        <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="li" fontWeight="bold" color="lightcoral">
          Check Fluids Monthly:
          <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="span" fontWeight="normal" color="white">
            {" "}
            Engine oil, coolant, washer fluid, brake fluid—ensure recommended
            levels and correct type.
          </Typography>
        </Typography>

        <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="li" fontWeight="bold" color="lightcoral">
          Tires – Pressure & Tread:
          <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="span" fontWeight="normal" color="white">
            {" "}
            Check pressure weekly, inspect tread depth, rotate regularly.
          </Typography>
        </Typography>

        <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="li" fontWeight="bold" color="lightcoral">
          Brakes:
          <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="span" fontWeight="normal" color="white">
            {" "}
            Listen for squeals or grinding; inspect if issues appear.
          </Typography>
        </Typography>

        <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="li" fontWeight="bold" color="lightcoral">
          Lights & Wipers:
          <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="span" fontWeight="normal" color="white">
            {" "}
            Test all exterior lights and replace streaking wipers.
          </Typography>
        </Typography>

        <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="li" fontWeight="bold" color="lightcoral">
          Battery Health:
          <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="span" fontWeight="normal" color="white">
            {" "}
            Watch for corrosion or slow starts; lasts 3–5 years typically.
          </Typography>
        </Typography>

        <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="li" fontWeight="bold" color="lightcoral">
          Filters:
          <Typography sx={{ margin: '1rem 0', fontSize: { xs: '0.8rem', sm: '1rem' }}} component="span" fontWeight="normal" color="white">
            {" "}
            Replace air & cabin filters every 12k–30k miles.
          </Typography>
        </Typography>
      </Box>
    </Paper>
  );
};

export default MaintenanceBanner;
